import useTranslation from 'shared/hooks/useTranslation';

import useQueryState from './useQueryState';

import { PageLoader, NoData, Error } from 'components';
import { Chat, EntityName } from 'features/chat';
import { EntityType, FileLoader } from 'features/file-loader';
import {
  Card,
  CardContainer,
  CardsColumn,
  CardsContainer,
  CardTitle,
  CaseContainer,
  CaseTitle,
} from 'shared/components/styled/Cases';
import CaseInfo from './CaseInfo';
import { CaseNumber, Status } from './KeyOrderViewForm.styled';

type KeyOrderViewFormProps = {
  caseId: string;
};

const KeyOrderViewForm = ({ caseId }: KeyOrderViewFormProps) => {
  const { t } = useTranslation();

  const { getKeyOrderCaseQueryState } = useQueryState({
    caseId,
  });

  const keyOrder = getKeyOrderCaseQueryState.data ?? null;

  if (getKeyOrderCaseQueryState.isError) return <Error />;
  if (
    getKeyOrderCaseQueryState.isLoading ||
    getKeyOrderCaseQueryState.isFetching
  )
    return <PageLoader />;
  if (!keyOrder) return <NoData />;

  return (
    <CaseContainer>
      <CaseTitle>
        Avaintilaus -{' '}
        <CaseNumber>
          {`#${keyOrder.Title}`} -{' '}
          {keyOrder.Status && (
            <Status status={keyOrder.Status.Value}>
              {keyOrder.Status.Label}
            </Status>
          )}
        </CaseNumber>
      </CaseTitle>
      <CardsContainer>
        <CardsColumn>
          <CaseInfo keyOrder={keyOrder} />
          <CardContainer>
            <CardTitle>{t('Documents')}</CardTitle>
            <Card>
              <FileLoader
                cached
                entityId={keyOrder.Id}
                entityType={EntityType.KeyOrder}
              />
            </Card>
          </CardContainer>
        </CardsColumn>
        <CardsColumn>
          <CardContainer>
            <CardTitle>{t('Chat')}</CardTitle>
            <Card sx={{ padding: 0 }}>
              <Chat entityId={keyOrder.Id} entityName={EntityName.Incident} />
            </Card>
          </CardContainer>
        </CardsColumn>
      </CardsContainer>
    </CaseContainer>
  );
};

export default KeyOrderViewForm;
